import { useOnlyFansCreators } from "@/common/hooks/useOnlyFansCreators";
import { OnlyFansCreator } from "../OnlyFansCreator";
import "./OnlyFansCreatorsModule.scss";
import { useDeviceType } from "@/common/hooks";
import { deviceTypeEnum } from "@/common/utils/device";

export const OnlyFansCreatorsModule = () => {
  const isDesktop = useDeviceType() === deviceTypeEnum.DESKTOP;

  const { adCreators } = useOnlyFansCreators("module", 4, !isDesktop);

  if (isDesktop) {
    return null;
  }

  return (
    <div className="FeedModule">
      <div className="OnlyFansCreatorsModule">
        <h3 className="title">Onlyfans creators you might enjoy:</h3>
        <div className="grid">
          {adCreators.map((adCreator) =>
            <OnlyFansCreator
              key={adCreator.extra.id}
              name={adCreator.extra.name}
              link={adCreator.link}
              image={adCreator.extra.imgUrl}
            />
          )}
        </div>
      </div>
    </div>
  );
};
